<script setup lang="ts">
import {type Component, type PropType} from 'vue';

export type SegmentOption = {
    value: string;
    label: string;
    icon?: Component;
};

defineProps({
    options   : {type: Array as PropType<SegmentOption[]>, required: true},
    modelValue: {type: String, required: true},
});
const emit = defineEmits<{ 'update:modelValue': [value: string] }>();
</script>

<template>
    <div class="inline-flex items-center gap-0.5 rounded-[10px] p-0.5" style="background: #e9ecef" role="radiogroup">
        <button
            v-for="o in options"
            :key="o.value"
            type="button"
            role="radio"
            class="inline-flex items-center gap-1.5 rounded-control px-3 py-1 text-sm cursor-pointer transition-colors"
            :class="o.value === modelValue ? 'bg-white text-zzc-antraciet font-semibold shadow-card' : 'text-zzc-muted hover:text-zzc-antraciet'"
            :aria-checked="o.value === modelValue ? 'true' : 'false'"
            @click="emit('update:modelValue', o.value)"
        >
            <component v-if="o.icon" :is="o.icon" :size="14" :stroke-width="2"/>
            {{ o.label }}
        </button>
    </div>
</template>
